import React, { useMemo } from 'react'
import Card from '../../../components/common/Card'
import { EnumTransactionType, Transaction } from '../../../services/transaction/transaction-typed'
import Table from '../../../components/common/Table'
import dayjs from 'dayjs'
import { pascalize } from 'humps'
import { replaceUnderScoreAndCapitalize } from '../../../../utils/helper'
import { EnumFrequencyDcaType, TransactionsDcaPlanList } from '../../../services/dca/dca-typed'
import styled from '@emotion/styled'
import { Typography } from '@material-ui/core'

const TextLib = styled(Typography)`
  line-height: 2 !important;
`

const TextColor = styled(TextLib)<{ color?: string }>`
  color: ${({ color }) => color};
  font-weight: bold !important;
`

interface TransactionCardProps {
  onPageChange: (page: number) => void
  transaction?: TransactionsDcaPlanList
}

export const DcaCard = (props: TransactionCardProps) => {
  const { transaction , onPageChange} = props


  const data = useMemo(() => {
    return transaction?.items?.map(e => {
      const { status, txId, createdAt, price, subscriptionId ,dcaDate: date , dcaType , dcaReference} = e
    
      const dcaDate = dcaReference
        ? dcaType === EnumFrequencyDcaType.MONTHLY
          ? `Every ${date} of the month`
          : `Every ${dayjs()
              .day(Number(date))
              .format('dddd')}`
        : '-'

      return {
        txId: txId || '',
        price: Number(price).toLocaleString() || '',
        type: subscriptionId
          ? replaceUnderScoreAndCapitalize(EnumTransactionType.DCA_RECURRING)
          : replaceUnderScoreAndCapitalize(EnumTransactionType.DCA_SETUP) || '',
        status: pascalize(status) || '',
        createdAt: dayjs(createdAt).format('YYYY-MM-DD HH:mm:ss') || '',
        date: dcaDate || '',
        dcaUnit: pascalize(dcaType || ''),
        subscriptionId: subscriptionId || '',
      }
    })
  }, [transaction])

  const columns = useMemo(() => {
    return (
      data?.length &&
      Object.keys(data[0]).map(key => {
        return {
          title: pascalize(key),
          dataIndex: key,
        }
      })
    )
  }, [data])
  return columns ? (
    <Card style={{ marginTop: 10 }}>
      <TextColor variant="h5">Transactions DCA</TextColor>
      <Table style={{ marginTop: 10 }} columns={columns} data={data} pagination={transaction?.meta} onPageChange={onPageChange}/>
    </Card>
  ) : (
    <></>
  )
}

export default DcaCard
